RivalIQ.apps.SocialPosts.module('views', function (views, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const FOOTER_MODE = {
        HideFooter: 'HideFooter',
        ManageTags: 'ManageTags',
        CreateNewTag: 'CreateNewTag',
        ApplyTag: 'ApplyTag',
        FilterTooLong: 'FilterTooLong',
        NoLinkedInBulkTagging: 'NoLinkedInBulkTagging'
    };

    // based on https://stackoverflow.com/a/37285344/5016993, with bug fixes and corrections for our specific positioning.
    function ensureInView(container, element) {

        if (!container || !element) {
            return;
        }

        const cTop = container.scrollTop + container.offsetTop;
        const cBottom = cTop + container.clientHeight;

        const eTop = element.offsetTop;
        const eBottom = eTop + element.clientHeight;

        if (eTop < cTop) {
            // scroll the container up so we're still in view
            container.scrollTop -= (cTop - eTop);
        } else if (eBottom > cBottom) {
            container.scrollTop += (eBottom - cBottom);
        }
    }

    views.InlinePostTagsAdder = Marionette.ItemView.extend({

        attributes: {
            style: 'width: 100%'
        },

        template: '#inlinePostTagsAdderTemplate',

        ui: {
            clearIcon: '.x-clear',
            searchIcon: '.x-search',
            filterInput: '.x-item-filter',
            footerAction: '.x-footer-action',
            postTags: 'a.post-tag',
            noPostTagsMessage: '.no-post-tags-message',
            postTagsContainer: '.dropdown-item-list',
            footer: '.footer'
        },

        events: {
            'click @ui.clearIcon': 'onClearClicked',
            'click @ui.postTags': 'onPostTagClicked',
            'click @ui.footerAction': 'onFooterClicked'
        },

        eventsNotToDebounce: {
            'keyup @ui.filterInput': 'onFilterKeyup'
        },

        initialize: function () {
            const me = this;

            me._anyDropdownShown = function (e) {
                if (e.relatedTarget !== me) {
                    me.destroy();
                }
            };

            $(document).on('show.bs.dropdown', me._anyDropdownShown);
        },

        onDestroy: function () {
            const me = this;

            $(document).off('click', me._onCloseHandler);
            $(document).off('show.bs.dropdown', me._anyDropdownShown);
        },

        onRender: function () {
            const me = this;

            if (!me._onCloseHandler) {
                me._onCloseHandler = function (e) {
                    e.stopPropagation();

                    if (me.$el.has(e.target).length) {
                        return;
                    }

                    $(document).off('click', me._onCloseHandler);
                    me.destroy();
                };
                $(document).on('click', me._onCloseHandler);
            }

            me.ui.filterInput.focus();

            me.$el.trigger($.Event('show.bs.dropdown', {
                relatedTarget: me
            }));
            me._updateFooterAction();
        },

        serializeData: function () {
            const me = this;

            const postTagsById = me.getOption('postTagsById');

            const existingPostIds = _.keyBy(me.getOption('post').get('post_tag_ids'));
            const postTags = _(postTagsById)
                .values()
                .reject(function (postTag) {
                    return existingPostIds[postTag.id];
                })
                .value();
            postTags.sort(function (a, b) {
                return a.tag_name.localeCompare(b.tag_name);
            });

            let emptyPostTagsMessage = null;
            if (!_.isEmpty(postTagsById) && _.isEmpty(postTags)) {
                emptyPostTagsMessage = RivalIQ.strings.single_post_all_tags_used;
            }

            return {
                postTags: postTags,
                emptyPostTagsMessage: emptyPostTagsMessage
            };
        },

        onFilterKeyup: function (e) {
            const me = this;

            switch (e.which) {

                case 13: {
                    e.preventDefault();

                    // if there is a selected option, do that.
                    const selectedRow = me.getCurrentSelected();
                    if (selectedRow && selectedRow.length) {
                        return selectedRow.click();
                    }

                    const footerMode = me._determineFooterMode();
                    if (footerMode === FOOTER_MODE.ApplyTag) {
                        const existingPostTag = me._findMatchingPostTag(me.ui.filterInput.val());
                        return me._applyPostTagToPost(existingPostTag.id);
                    }

                    if (footerMode === FOOTER_MODE.CreateNewTag) {
                        return me._createAndApplyPostTag(me.ui.filterInput.val());
                    }

                    break;
                }
                case 38:
                case 40:
                    return me._updateSelected(e.which === 40);
                default:
                    break;
            }

            // if we had the footer selected before, unselect it.
            me.ui.footerAction.removeClass('selected');

            me.filterPostTags();
        },

        _updateSelected: function (down) {
            const me = this;

            const allLinks = me.$el.find('a:visible');

            if (!allLinks.length) {
                return;
            }

            const currentSelectedIdx = _.findIndex(allLinks, function (link) {
                return $(link).hasClass('selected');
            });

            let nextSelectionIdx;
            if (currentSelectedIdx === -1) {
                nextSelectionIdx = 0;
            } else {
                nextSelectionIdx = (currentSelectedIdx + (down ? 1 : -1)) % allLinks.length;
            }

            me.$el.find('a').removeClass('selected');

            const nextSelected = $(allLinks[nextSelectionIdx]);
            nextSelected.addClass('selected');

            // scroll if not visible
            ensureInView(me.ui.postTagsContainer[0], nextSelected[0]);
        },

        getCurrentSelected: function () {
            const me = this;

            return me.$el.find('a.selected:visible');
        },

        onClearClicked: function () {
            const me = this;

            me.ui.filterInput.val('');
            me.filterPostTags();
        },

        filterPostTags: function () {
            const me = this;

            const filterText = me.ui.filterInput.val().trim().toLocaleLowerCase();
            me.ui.clearIcon.toggleClass('display-none', _.isEmpty(filterText));
            me.ui.searchIcon.toggleClass('display-none', !_.isEmpty(filterText));
            me.ui.noPostTagsMessage.toggleClass('display-none', !_.isEmpty(filterText));

            const postTagsById = me.getOption('postTagsById');

            const postTags = _.values(postTagsById);
            _.each(postTags, function (postTag) {
                const show = _.includes(postTag.tag_name.toLocaleLowerCase(), filterText);
                me.$el.find(`li#post-tag-${postTag.id}`).toggleClass('display-none', !show);
            });

            me._updateFooterAction();

            me.$el.find('a.selected:not(:visible)').removeClass('selected');
        },

        onFooterClicked: function () {
            const me = this;

            switch (me._determineFooterMode()) {
                case FOOTER_MODE.ManageTags: {
                    const dashboardModel = me.getOption('dashboardModel');

                    const sourceDetails = RivalIQ.enums.sourceDetails;
                    const specificSourceDetails = _.get(sourceDetails, [me.options.post.get('source')]);

                    const clickSourceInfo = {
                        clickSource: 'singlePostDropdown',
                        feature: 'social posts',
                        channel: _.get(specificSourceDetails, ['channel'])
                    };

                    let additionalProps = undefined;

                    if (_.get(specificSourceDetails, ['privateData'])) {
                        clickSourceInfo.feature = 'private data';
                        additionalProps = {
                            fromCurationId: dashboardModel.getCuration().id,
                            fromCurationCompanyId: dashboardModel.getProp('companyId')
                        };
                    }

                    App.utils.showPostTagsManager(dashboardModel, clickSourceInfo, additionalProps);
                    me.destroy();
                    break;
                }
                case FOOTER_MODE.FilterTooLong:
                    break;

                case FOOTER_MODE.ApplyTag: {
                    const existingPostTag = me._findMatchingPostTag(me.ui.filterInput.val());
                    return me._applyPostTagToPost(existingPostTag.id);
                }
                case FOOTER_MODE.CreateNewTag:
                    return me._createAndApplyPostTag(me.ui.filterInput.val());
                default:
                    throw new Error(`unknown footer mode ${me._determineFooterMode()}`);
            }
        },

        _updateFooterAction: function () {
            const me = this;

            const filterText = me.ui.filterInput.val().trim();
            me.ui.footer.show();
            me.ui.footerAction.removeClass('disabled');
            switch (me._determineFooterMode()) {

                case FOOTER_MODE.HideFooter:
                    me.ui.footer.hide();
                    break;

                case FOOTER_MODE.ManageTags:
                    me.ui.footerAction.html('Post Tag Manager');
                    me.ui.footerAction.removeClass('has-error');
                    break;

                case FOOTER_MODE.NoLinkedInBulkTagging:
                    me.ui.footerAction.html('No bulk editing in LinkedIn');
                    me.ui.footerAction.removeClass('has-error');
                    me.ui.footerAction.addClass('disabled');
                    break;

                case FOOTER_MODE.FilterTooLong:
                    me.ui.footerAction.text(`Tag must be ${RivalIQ.postTags.MAX_POST_TAG_LENGTH} characters or less.`);
                    me.ui.footerAction.addClass('has-error');
                    break;

                case FOOTER_MODE.ApplyTag: {
                    const existingPostTag = me._findMatchingPostTag(filterText);
                    me.ui.footerAction.text(`Apply Tag "${existingPostTag.tag_name}"`);
                    me.ui.footerAction.removeClass('has-error');
                    break;
                }
                case FOOTER_MODE.CreateNewTag:
                    me.ui.footerAction.text(`Create Post Tag "${filterText}"`);
                    me.ui.footerAction.removeClass('has-error');
                    break;
                default:
                    throw new Error(`unknown footer mode ${me._determineFooterMode()}`);
            }
        },

        _findMatchingPostTag: function (tagName) {
            const me = this;

            // See there's an exact match for an existing tag.
            const postTags = _.values(me.getOption('postTagsById'));
            const lcNewTagName = tagName.trim().toLocaleLowerCase();
            return _.find(postTags, function (postTag) {
                return postTag.tag_name.toLocaleLowerCase() === lcNewTagName;
            });
        },

        _determineFooterMode: function () {
            const me = this;

            const filterText = me.ui.filterInput.val().trim();
            if (_.isEmpty(filterText)) {
                if (me.options.post.get('source') === RivalIQ.enums.sources.LINKEDIN) {
                    return FOOTER_MODE.NoLinkedInBulkTagging;
                } else {
                    return FOOTER_MODE.ManageTags;
                }
            } else if (filterText.length > RivalIQ.postTags.MAX_POST_TAG_LENGTH) {
                return FOOTER_MODE.FilterTooLong;
            } else {
                const existingPostTag = me._findMatchingPostTag(filterText);
                if (existingPostTag) {
                    return FOOTER_MODE.ApplyTag;
                } else {
                    return FOOTER_MODE.CreateNewTag;
                }
            }
        },

        onPostTagClicked: function (e) {
            const me = this;

            const $target = $(e.target);
            const postTagId = $target.data('post-tag-id');

            me._applyPostTagToPost(postTagId);
        },

        _createAndApplyPostTag: function (postTagName) {
            const me = this;

            let postTag = new RivalIQ.postTags.models.PostTag({
                tag_name: postTagName
            });

            postTag
                .save()
                .done(function () {
                    RivalIQ.postTags.data.PostTags.onPostTagCreated(postTag);
                    return me._applyPostTagToPost(postTag.id);
                })
                .fail(function (error) {
                    if (error.status === 409) {
                        // we already have a tag with this name, use it.
                        postTag = new RivalIQ.postTags.models.PostTag(error.errorData);
                        RivalIQ.postTags.data.PostTags.onPostTagCreated(postTag);
                        return me._applyPostTagToPost(postTag.id);
                    }

                    RivalIQ.execute('alert:danger', 'An error occurred, please try again');
                });
        },

        _applyPostTagToPost: function (postTagId) {
            const me = this;

            const post = me.getOption('post');
            const channel = RivalIQ.enums.sourceDetails[post.get('source')].channel;
            const posts = [{
                channel: channel,
                postNativeIds: [post.get('native_id')]
            }];

            // NOTE: being optimistic here and updating the UI before the changes were saved to the server;
            // It's possible the server fails, which will leave the UI with the wrong tags applied, but the
            // only error cases we should get are server outages/network issues.
            const postTagsById = me.getOption('postTagsById');
            post.attributes.post_tag_ids = _.union(post.attributes.post_tag_ids, [postTagId]);
            RivalIQ.postTags.data.PostTags.trigger('postTag:applied', postTagsById[postTagId], post);
            me.$el.hide();

            const postSource = RivalIQ.data.channels.get(post.attributes.source);
            const feature = (postSource && postSource.get('privateData') ? 'private data' : 'social posts');

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.AppliedPostTags, {
                queryModeEnabled: false,
                numPosts: 1,
                numTagsToAdd: 1,
                numTagsToRemove: 0,
                source: 'singlePostDropdown',
                feature: feature
            });

            RivalIQ.postTags.data.PostTags.updateAssociations([postTagId], undefined, posts)
                .always(function () {
                    me.destroy();
                })
                .fail(function () {
                    RivalIQ.execute('alert:danger', 'An error occurred, please try again');
                });
        }
    });
});
